import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { movieService } from '../services/movie-service.js'
import MovieFilter from '../views/MovieFilter.jsx'
import MovieCard from '../views/MovieCard.jsx'
import MovieRow from '../views/MovieRow.jsx'
import Hero from '../views/Hero.jsx'
import { SkeletonGrid } from '../views/Skeleton.jsx'

const TvShows = () => {
  const [filterBy, setFilterBy] = useState({
    movieTitle: '',
    rating: '',
    year: '',
  })

  const [filteredTvShows, setFilteredTvShows] = useState()
  const [tvShows, setTvShows] = useState()
  const navigate = useNavigate()
  const [displayCount, setDisplayCount] = useState(18)

  const [rows, setRows] = useState({ trending: [], top_rated: [], on_the_air: [] })
  const [rowsLoading, setRowsLoading] = useState(true)

  useEffect(() => {
    loadTvShows()
    loadRows()
  }, [])

  useEffect(() => {
    if (tvShows) {
      setFilteredTvShows(tvShows.filter(filterTvShow))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tvShows, filterBy])

  const handleReadMore = (result) => {
    navigate(`/show/${result.id}`, {
      state: { media: result, fromSearch: false },
    })
  }

  async function loadTvShows() {
    const list = await movieService.getTvShows()
    setTvShows(list)
  }

  async function loadRows() {
    setRowsLoading(true)
    const [trending, topRated, onTheAir] = await Promise.all([
      movieService.getTrendingTv(),
      movieService.getTvByCategory('top_rated'),
      movieService.getTvByCategory('on_the_air'),
    ])
    setRows({ trending, top_rated: topRated, on_the_air: onTheAir })
    setRowsLoading(false)
  }

  const handleLoadMore = () => setDisplayCount(displayCount + 18)
  const handleSetFilter = (newFilterBy) => setFilterBy(newFilterBy)

  const filterTvShow = (tvShow) => {
    const { movieTitle, rating, year } = filterBy
    if (
      movieTitle &&
      !tvShow.name.toLowerCase().includes(movieTitle.toLowerCase())
    ) {
      return false
    }
    if (rating && tvShow.vote_average < rating) return false
    if (year) {
      const date = tvShow.first_air_date || tvShow.release_date
      if (!date || date.substring(0, 4) !== year) return false
    }
    return true
  }

  return (
    <>
      <Hero type='tv' />

      <MovieRow
        title='Trending This Week'
        eyebrow='Hot right now'
        items={rows.trending}
        loading={rowsLoading}
        onReadMore={handleReadMore}
      />
      <MovieRow
        title='Top Rated'
        eyebrow='Critically acclaimed'
        items={rows.top_rated}
        loading={rowsLoading}
        onReadMore={handleReadMore}
      />
      <MovieRow
        title='On The Air'
        eyebrow='Airing now'
        items={rows.on_the_air}
        loading={rowsLoading}
        onReadMore={handleReadMore}
      />

      <section id='movies'>
        <div className='container movies-container'>
          <div className='section-head'>
            <span className='eyebrow'>Browse the library</span>
            <h1>All TV Shows</h1>
            <p className='sub'>
              {filteredTvShows ? `${filteredTvShows.length} series` : 'Loading'} —
              search, filter by year and rating.
            </p>
          </div>

          <MovieFilter onSetFilter={handleSetFilter} />

          {filteredTvShows ? (
            <>
              <div className='movie-grid grid'>
                {filteredTvShows
                  .filter((tv) => tv.poster_path)
                  .slice(0, displayCount)
                  .map((tVShow) => (
                    <MovieCard
                      key={tVShow.id}
                      media={tVShow}
                      onReadMore={handleReadMore}
                    />
                  ))}
              </div>

              {displayCount < filteredTvShows.length && (
                <div className='load-more-btn flex center'>
                  <button className='btn btn-primary' onClick={handleLoadMore}>
                    Load More
                  </button>
                </div>
              )}
            </>
          ) : (
            <SkeletonGrid count={18} />
          )}
        </div>
      </section>
    </>
  )
}

export default TvShows
